import { render, staticRenderFns } from "./ConfigurationIncidentOriginsModal.vue?vue&type=template&id=491318b5&"
import script from "./ConfigurationIncidentOriginsModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIncidentOriginsModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationIncidentOriginsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports